import { ScrollProvider, Header } from '@/components'
import { ParallaxProvider } from "react-scroll-parallax";
import { Toaster } from "react-hot-toast";
import ArticlesRouter from '@/router/articles'

// Articles run on real paths (/articles/:id) under a BrowserRouter, mounted by
// src/index.tsx when window.location.pathname starts with /articles.
function ArticlesApp() {
  return (
    <ParallaxProvider>
      <ScrollProvider>
        <Header />
        <ArticlesRouter />
        <Toaster />
      </ScrollProvider>
    </ParallaxProvider>
  );
}

export default ArticlesApp;
